import type { CacheKey } from '../utils/internalTypings';
import { KeyNamespaces, getKey } from '../utils/getKey';

export const getQueryKey = <PayloadArg>(
    options: {
        cacheKey?: CacheKey<PayloadArg>;
        name: string;
    },
    arg?: PayloadArg,
): string[] => getKey(KeyNamespaces.QUERIES, options, arg);
